import React from 'react'
import PropTypes from 'prop-types'

export const BENCHMARK_HELP_URL = 'https://help.simplesat.io/en/articles/16996084-benchmarks'

export default function BenchmarkInfoContent({ workspaceToken, canManageWorkspaceSettings }) {
  return (
    <React.Fragment>
      <p>Compare your CSAT and NPS with similar companies using Simplesat&apos;s benchmark data.</p>
      <p>
        You can change your industry if you have access to{' '}
        {canManageWorkspaceSettings ? (
          <a href={`/${workspaceToken}/settings/workspace/`}>workspace settings</a>
        ) : (
          'workspace settings'
        )}
        .
      </p>
      <p>If your industry has limited data, the all-industry benchmark is shown.</p>
    </React.Fragment>
  )
}

BenchmarkInfoContent.propTypes = {
  workspaceToken: PropTypes.string,
  canManageWorkspaceSettings: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/BenchmarkInfoContent/index.js